import React from 'react';
import _ from 'lodash';
import {Input, Textarea, Checkbox, Select} from './Form';

/**
    Class to help with default form values in React
    More info: https://facebook.github.io/react/docs/forms.html#controlled-components
*/
export default class FormHelper {

  constructor(onChange) {
    this._storage = {};
    this._onChangeCallback = onChange;
    this._onChange = this._onChange.bind(this);
  }

  setStorage(storage) {
    this._storage = storage;
  }

  _onChange(e) {
    const target = e.target;
    const inputType = target.type;

    const newValue = (inputType === 'checkbox' ? !!target.checked : target.value);
    _.set(this._storage, target.name, newValue);

    this._onChangeCallback(this._storage);
  }

  getInput(label, name, placeholder, options = {}) {
    const optProps = Object.assign({
      type: 'text',
      required: false,
      invalidMsg: 'Please enter a valid value',
    }, options);

    const reqProps = {
      name, label,
      placeholder,
      value: _.get(this._storage, name, ''),
      onChange: this._onChange,
    };

    if (optProps.type === 'textarea') {
      return (
        <Textarea {...reqProps} {...optProps} />
      );
    }

    return (
      <Input {...reqProps} {...optProps} />
    );
  }

  getCheckbox(label, name) {
    return (
      <Checkbox
        name={name}
        label={label}
        checked={_.get(this._storage, name, false)}
        onChange={this._onChange}
      />
    );
  }

  getSelect(label, name, optionsEls) {
    return (
      <Select
        name={name}
        label={label}
        value={_.get(this._storage, name, '')}
        onChange={this._onChange}
      >
        {optionsEls}
      </Select>
    );
  }

}
